import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-course-lesson-quiz.tsx
var LazyCourseLessonQuiz = lazy(() => import("./course-lesson-quiz-CcU5Gv-o.js").then((n) => n.n).then((module) => ({ default: module.CourseLessonQuiz })));
function CourseLessonQuiz({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-lesson-quiz" }),
		children: /* @__PURE__ */ jsx(LazyCourseLessonQuiz, { ...props })
	});
}
function CourseLessonQuizContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-lesson-quiz" }),
		children: /* @__PURE__ */ jsx(LazyCourseLessonQuiz, { ...props })
	});
}
var useCourseLessonQuizContent = () => {
	return useMemo(() => ({ courseLessonQuiz: { component: CourseLessonQuizContent } }), []);
};
//#endregion
export { CourseLessonQuiz, useCourseLessonQuizContent };
